import { observable } from "mobx";
import Model from "~/models/Model";

class UiMeet3dPhoto extends Model {
  /**
   * @property {number|null}
   */
  @observable uiMeet3dPhotoId = null;

  /**
   * @property {number}
   */
  @observable type = null;

  /**
   * @property {string|null}
   */
  @observable photoUrl = null;

  /**
   * @property {number|null}
   */
  @observable photoWidth = null;

  /**
   * @property {number|null}
   */
  @observable photoHeight = null;

  /**
   * @property {string|null}
   */
  @observable photoPathWeb = null;
}

export default UiMeet3dPhoto;
